import { init } from "@rematch/core"
import models from "./models"
import createPersistPlugin, { getPersistor } from "@rematch/persist"
import { PersistGate } from "redux-persist/es/integration/react"
import storage from "redux-persist/lib/storage"
import createSelectPlugin from "@rematch/select"
import createLoadingPlugin from "@rematch/loading"
import {
  createFilter,
  createBlacklistFilter
} from "redux-persist-transform-filter"
const loadingPlugin = createLoadingPlugin({ type: "full" })

const saveSubsetFilterAuth = createFilter("auth", [
  "attributes",
  "group",
  "redirect",
  "state",
  "loggedIn",
  "action"
])
const saveSubsetFilterRealState = createFilter("realState", [
  "currentUuid",
  "isContractSaved",
  "savedProperty",
  "data"
])
const saveSubsetFilterSystem = createFilter("system", ["toast"])
const persistPlugin = createPersistPlugin({
  key: "root",
  storage,
  whitelist: ["auth", "system"],
  transforms: [saveSubsetFilterAuth, saveSubsetFilterRealState],
  version: 2
})

const store = init({
  models,
  plugins: [createSelectPlugin(), loadingPlugin, persistPlugin]
})
const dispatch = store.dispatch

export { store, dispatch }
